Vue.component('playingCard', {
  template: templates.playingCard,
  props: ['card', 'show', 'cover'],
  data() {
    return {
      model: {
        show: false,
        cover: false,
        showAbility: false,
        timer: null,
        cooldown: this.card.cooldown,
        isDragging: false,
        menuVisible: false,
        menuX: 0,
        menuY: 0,
        isFlipped: false,
        tooltipMessage: '',
        isBeating: false,
        xpReady: false
      }
    }
  },
  computed: {
    cardStatus() {
      const c = this;

      // Check if card has isLegacy flag
      if (c.card.isLegacy === undefined) {
        return null;
      }

      return c.card.isLegacy ? 'Legacy' : 'Seasonal';
    }
  },
  mounted() {
    const c = this;
    if (c.show) {
      c.model.show = true;
    }

    c.$nextTick(() => { c.model.xpReady = true; });

    if (c.cover) {
      c.model.cover = true;
    }

    c.$root.$on(`flip${this.card.id}`, id => {
      c.flip(id);
    });

    c.$root.$on(`say${this.card.cardNumber}`, data => {
      c.model.tooltipMessage = data.message

      const $card = $(`.chamber-select[data-number="${data.cards.cardNumber}"] .tooltip:visible`);

      $card.addClass('show');

      setTimeout(function() {
        $card.removeClass('show');
      }, 5000);
    });

    if (c.card.cooldown) {
      c.timer();
    }
  },
  watch: {
    card: function() {
      const c = this;

      c.model.timer = null;
      
      if (c.card.cooldown) {
        clearInterval(c.model.timer);
        c.timer();
      }
    }
  },
  methods: {
    timer() { 
      const c = this;

      let seconds = Math.round(c.card.cooldown * 60);

      c.model.timer = setInterval(function() {
        seconds -= 1;

        if (seconds > -1) {
          c.card.cooldown = c.format(seconds);
        } else {
          c.card.cooldown = null;
          clearInterval(c.model.timer);
        }

      }, 1000);

    },
    format(time) {
      // Hours, minutes and seconds
      var hrs = ~~(time / 3600);
      var mins = ~~((time % 3600) / 60);
      var secs = ~~time % 60;

      // Output like "1:01" or "4:03:59" or "123:03:59"
      var ret = "";
      if (hrs > 0) {
          ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
      }
      ret += "" + mins + ":" + (secs < 10 ? "0" : "");
      ret += "" + secs;
      return ret;
    },
    flip(id) {
      if (id) {
        const c = this;
        
        const $card = $(`[data-id="${id}"] .playing-card:visible`);
        //$card.addClass('playing-card--flipped');

        // if($card.hasClass('flipped')) {
        //   $card.addClass('unflip');
        //   setTimeout(function(){
        //     $card.removeClass('flipped').removeClass('unflip');
        //   }, 500);
        // }
        // else { 
          
          // If not, add the 'flipped' class
          $card.addClass('flipped');
        // }
      }
    },
    select(card) {
      //card.selected = card.selected ? false : true;
    },
    onDragStart(event) {
      const c = this;

      console.log(this.card)
      const cardData = JSON.stringify(this.card);
      event.dataTransfer.setData('text/plain', JSON.stringify(this.card));

      const $card = $(`[data-number="${this.card.cardNumber}"].asd`)
      const $playingCardFront = $card.find('.playing-card-face');

      $playingCardFront.removeClass('playing-card-backing')
      // $playingCardFront.addClass('dragging')
  },
  onDragEnd(event) {
    const c = this;
    c.model.isDragging = false;
  

    const $card = $(`[data-number="${this.card.cardNumber}"].asd`)
    const $playingCardFront = $card.find('.playing-card-face');

    $playingCardFront.removeClass('dragging')
    
  },
  onDragOver(event) {
    const c = this;
    event.preventDefault(); 
    c.model.isDragging = true;
  },
  onDragLeave(event) {
    const c = this;
    c.model.isDragging = false;

  },
  onDrop(event, card) {
      const c = this;
      event.preventDefault();
      c.model.isDragging = false;
      const cardData = event.dataTransfer.getData('text/plain');

      const parsedCard  = JSON.parse(cardData);

      if(parsedCard.tier === 5){

        $('.modal').addClass('is-above').addClass('is-visible');
        // const $card = $(`[data-id="${card.id}"] .playing-card-wrapper`);

        c.$root.$emit('boneCardAccept', {card: c.addCardStats(parsedCard, card),bone: parsedCard,  message: `Are you sure you want to equip ${parsedCard.name}card to card number #${card.cardNumber}?`});

        // c.$root.$emit('boneCardAddded', {card: c.addCardStats(parsedCard, card),boneId: parsedCard.cardId,value: parsedCard.value});

      } else if (parsedCard.tier === 10) {
        if (card.deltaCardKey) {
          alert('This card already has a Delta Card equipped.');
          return;
        }
        const reachLevel = parsedCard.min_card_level || 0;
        const cardLevel = card.level || 0;
        if (reachLevel > 0 && cardLevel < reachLevel) {
          utils.alert.error(`This Delta Card requires card level ${reachLevel}. Your card is level ${cardLevel}.`);
          return;
        }
        $('.modal').addClass('is-above').addClass('is-visible');
        c.$root.$emit('deltaCardAccept', {
          card: card,
          delta: parsedCard,
          message: `Are you sure you want to equip ${parsedCard.name} to card number #${card.cardNumber}?`
        });
      }
  },
  showContextMenu(event) {
    const c = this;
    c.model.menuVisible = true;
    c.model.menuX = event.clientX;
    c.model.menuY = event.clientY;
  },
  closeContextMenu() {
    const c = this;
    c.model.menuVisible = false;
  },
  addFavorites() {
    const c = this;

    c.closeContextMenu();
    userService.addRemoveToFavorites({cardNumber: c.card.cardNumber, twitchId: utils.cookies.get('user_id'), add: true, dateCreated: c.card.dateCreated})
    .then(function (response) {
      c.$root.$emit('updateCards');
    })

  },
  removeFavorites() {
    const c = this;

    c.closeContextMenu();
    userService.addRemoveToFavorites({cardNumber: c.card.cardNumber, twitchId: utils.cookies.get('user_id'), add: false, dateCreated: c.card.dateCreated})
    .then(function (response) {
      c.$root.$emit('updateCards');
    })

  },
  addCardStats(parsedCard, card){
    const c = this;

      //add defence
      if(parsedCard.cardId === 'E93B9010-F704-4E0D-AF90-75B5E71BCAD8'){
        card.defence += Math.round(parsedCard.value)
        return card;
      }
      //add speed
      if(parsedCard.cardId === '30C78656-D0C5-457C-8E85-3FC573068C3E'){
        card.speed += Math.round(parsedCard.value)
        return card;
      }
      //add accuracy
      if(parsedCard.cardId === '40D6A0B4-625E-45B9-8C3B-FB0FB29444E6'){
        card.accuracy += Math.round(card.accuracy * parsedCard.value)
        return card;
      }
      //add attack
      if(parsedCard.cardId === '89D0C026-3972-40F7-8459-C0CBF4830103'){
        card.attack += Math.round(parsedCard.value)
        return card;
      }
      //add hp
      if(parsedCard.cardId === 'EB9D0482-ADFE-4E11-9606-B613E918D013'){
        card.hp += Math.round(parsedCard.value)
        return card;
      }
  },
  cardReveal(){
    const c = this;
    if (c.model.isBeating) return;
    c.model.isBeating = true;
    setTimeout(() => { c.model.isBeating = false; }, 1200);
    c.$root.$emit('cardReveal');
  }
  }
});